export enum LocalStorageEnum {
  token = '_t',
  user_id = '_u',
  refresh_token = '_rft',
  permissions = '_perm',
  role = '_r',
  school_id = '_school',
  language = '_lang',
  required_change_password = '_rcp',
  otp_token = '_otp_t',
}
